<template>
    <div class="land-promo">
        <div class="promo-pic" :style="'background-image: url(' + salesCard.shablon_main_pic + ')'" v-if="!isMobileChecker"></div>
        <div class="promo-pic-mobile" :style="'background-image: url(' + salesCard.shablon_main_pic_mobile + ')'" v-if="isMobileChecker">
            <div class="promo-title-mobile" v-if="isMobileChecker && projectNameG != 'riviera-plus'">
                <h2 v-html="salesCard.shablon_project_title"></h2>
            </div>
            <div class="seismo-title-mobile" v-if="isMobileChecker && projectNameG == 'riviera-plus'">
                    <h2 v-html="salesCard.shablon_project_seismo_title"></h2>
                </div>
        </div>
        <div class="container">
            <div class="land-promo-container">
                <div class="promo-title" v-if="!isMobileChecker && projectNameG != 'riviera-plus'">
                    <h2 v-html="salesCard.shablon_project_title"></h2>
                </div>
                <div class="seismo-title" v-if="!isMobileChecker && projectNameG == 'riviera-plus'">
                    <h2 v-html="salesCard.shablon_project_seismo_title"></h2>
                </div>
                <div class="promo-btns-mobile" v-if="isMobileChecker">
                    <ul>
                        <li :class="{'full-view' : salesCard.present_file.file == false && lang != 'kz/' || salesCard.present_file.file_kz == false && lang == 'kz/'}">
                            <a href="#" v-scroll-to="{el: '#land-plans', offset: 0}" class="flat-link">{{salesCard.shablon_btn_flat}}</a>
                        </li>
                        <li v-if="salesCard.present_file.file != false && lang != 'kz/'">
                            <a :href="salesCard.present_file.file" target="_blank">{{salesCard.present_file.name}}</a>
                        </li>
                        <li v-if="salesCard.present_file.file_kz != false && lang == 'kz/'">
                            <a :href="salesCard.present_file.file_kz" target="_blank">{{salesCard.present_file.name}}</a>
                        </li>
                        <li class="online-book" v-if="salesCard.site_shablon_online_booking_init == 'true'">
                            <a href="#" v-scroll-to="{el: '#land-plans', offset: 0}" class="book-link">{{salesCard.shablon_btn_book_online}}</a>
                        </li>
                    </ul>
                </div>
                <div class="project-adres-container" :class="{'online-book' : salesCard.site_shablon_online_booking_init == 'true'}">
                    <div class="project-adres">
                        <svgIcon name="pin-map" />
                        <p v-html="salesCard.shablon_house_adres"></p>
                    </div>
                    <li class="online-book" v-if="salesCard.site_shablon_online_booking_init == 'true' && !isMobileChecker">
                        <a href="#" v-scroll-to="{el: '#land-plans', offset: 0}" class="book-link">{{salesCard.shablon_btn_book_online}}</a>
                    </li>
                    <!-- <li v-if="salesCard.present_file.file != false && lang != 'kz/' && !isMobileChecker && projectNameG != 'duman'" class="present-link">
                        <a :href="salesCard.present_file.file" target="_blank">{{salesCard.present_file.name}}</a>
                    </li>
                    <li v-if="salesCard.present_file.file_kz != false && lang == 'kz/' && !isMobileChecker && projectNameG != 'duman'" class="present-link">
                        <a :href="salesCard.present_file.file_kz" target="_blank">{{salesCard.present_file.name}}</a>
                    </li> -->
                    <li v-if="salesCard.video_init == 'true' && projectNameG == 'duman' || projectNameG == 'lmgold'" class="present-link">
                        <a href="#" class="btn-v" v-scroll-to="{el: '#land-video', offset: -50}">
                            <span>{{ salesCard.shablon_btn_video }}</span>
                        </a>
                    </li>
                    <li v-if="salesCard.video_init == 'true' && projectNameG == 'riviera-plus'" class="present-link">
                        <a href="#" class="btn-v" v-scroll-to="{el: '#land-video', offset: -50}">
                            <span>{{ salesCard.shablon_btn_video }}</span>
                        </a>
                    </li>
                </div>
                <div class="project-main-info-pins">
                    <div class="pin-item" v-for="(item, index) in salesCard.shablon_main_info_icons" :key="index">
                        <div class="pin-icon">
                            <img :src="item.icon" alt=""> 
                        </div>
                        <div class="pin-info">
                            <strong v-if="index == 'price' && objectDataCRM != null && salesCard.site_shablon_price_init == 'true' && projectNameG != 'lmgold'"><span v-if="lang != 'kz/'">от</span> {{objectDataCRM.minMeterPrice}} <span>тг/м2</span></strong>
                            <strong v-if="index == 'price' && salesCard.site_shablon_price_init == 'true' && projectNameG == 'lmgold' && LDM_complex != null">
                                <span v-if="lang == ''">от</span>
                                {{ getNumber(LDM_complex) }}
                                <span v-if="lang == ''">тг.</span><span v-if="lang == 'kz/'">тг.бас.</span>
                            </strong>
                            <strong v-if="index == 'price' && objectDataCRM != null && salesCard.site_shablon_price_init == 'false'">
                                <span v-if="lang == ''">По запросу</span>
                                <span v-else>Сұраныс бойынша</span>
                            </strong>
                            <strong v-if="index != 'price'">{{item.info}}</strong>
                            <span class="name">{{item.name}}</span>
                        </div>
                        <!-- {{index}} -->
                    </div>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'sale-land-promo',
        components: {
            svgIcon,
        },
        data () {
            return {
                projectNameG: window.host,
                lang: window.GlobalLang,
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            objectDataCRM: 'loadObjectDataCrm',
            isMobileChecker: 'loadIsMobileChecker',
            LDM_complex: 'loadLDM_complex',
        }),
        methods: {
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.$store.dispatch('getObjectFromCRM', {
                "complexCodes": [this.salesCard.crm_code]
            })
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-promo.scss';
    @import '@/styles/components/sales/respond/land-promo-respond.scss';
</style>